export enum ApiTemporaryUrls {
  AdminsGetTeacher = '/saas/v1.0/admins/getteacher',
  SchoolAdminsGetTeacher = '/saas/v1.0/schooladmins/getteacher',
  GetTeacher = '/saas/v1.0/saas/getteacher',
}
